import { render, staticRenderFns } from "./subHorizontalMenu.vue?vue&type=template&id=52b93417"
import script from "./subHorizontalMenu.vue?vue&type=script&lang=js"
export * from "./subHorizontalMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports